// FolderInput.tsx
import React from 'react';
import { useFolderSelect } from '../../../hooks/useFolderSelect';

const FolderInput: React.FC = () => {
  const { folderName, showFolderDialog } = useFolderSelect();

  return (
    <div className="flex flex-col">
      <span className="text-[10px] text-[#9D9DA6] uppercase">FOLDER</span>
      <span className="text-[#9D9DA6] underline cursor-pointer hover:text-jen-orange transition-colors" onClick={showFolderDialog}>
        {folderName ?? 'Add'}
      </span>
    </div>
  );
};

export default FolderInput;
